if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.buttonText = this.button.querySelector('span');
        this.spinner = this.querySelector('.loading__spinner');
        this.sourceButton = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);

        if (!this.sourceButton) return;

        this.syncState();
        this.observeState();
        this.observeVisibility();

        // Varyant değişiminde product-info section'ı yeniden render edebilir,
        // o durumda kaybolan referansları tazele
        if (typeof subscribe === 'function') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
            const currentSource = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
            if (currentSource && currentSource !== this.sourceButton) {
              this.sourceButton = currentSource;
              this.observeState();
              this.observeVisibility();
            }
            this.syncState();
          });
        }
      }

      disconnectedCallback() {
        this.stateObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
        document.body.classList.remove('sticky-atc-visible');
      }

      // Etiket ve durum tek kaynaktan gelir: sayfadaki asıl sepete ekle butonu
      // (product-info.js → toggleSubmitButton, product-form.js → loading state)
      syncState() {
        const isLoading = this.sourceButton.classList.contains('loading');

        this.button.disabled = this.sourceButton.hasAttribute('disabled');
        this.button.classList.toggle('loading', isLoading);
        this.button.toggleAttribute('aria-disabled', this.sourceButton.getAttribute('aria-disabled') === 'true');
        this.spinner?.classList.toggle('hidden', !isLoading);

        const sourceText = this.sourceButton.querySelector('span')?.textContent;
        if (sourceText) this.buttonText.textContent = sourceText;
      }

      observeState() {
        this.stateObserver?.disconnect();
        this.stateObserver = new MutationObserver(() => this.syncState());
        this.stateObserver.observe(this.sourceButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      // Asıl buton ekranda görünürken sticky bar gereksiz — sadece kaybolunca çık
      observeVisibility() {
        this.visibilityObserver?.disconnect();
        this.visibilityObserver = new IntersectionObserver(
          (entries) => this.toggleBar(!entries[0].isIntersecting),
          { rootMargin: '0px 0px -80px 0px' }
        );
        this.visibilityObserver.observe(this.sourceButton);
      }

      toggleBar(visible) {
        this.classList.toggle('sticky-atc--visible', visible);
        document.body.classList.toggle('sticky-atc-visible', visible);

        if (visible) {
          document.body.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
        }
      }
    }
  );
}
